module.exports = __webpack_public_path__ + "img/coin5.9f18d2d0.png";